<!-- H5页面，流程项目选择 -->
<template>
  <div class="prjSelectH5">
    <van-field readonly :is-link="!readonly" :value="prjName" label="流程项目" placeholder="选择项目" @click="openPri" />
    <!-- 弹框 -->
    <van-popup v-model="showPrj" round position="bottom">
      <van-search v-model="keyword" placeholder="请输入关键词" class="searchRow" @search="getPrjOptions" @clear="getPrjOptions" />
      <van-picker v-if="prjOptions?.length" :columns="prjOptions">
        <template #option="option">
          <div class="oneCell" @click="priConfirm(option)">{{ option.prjName }}</div>
        </template>
      </van-picker>
      <div v-else class="empty">暂无数据</div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import XtDesignService from "@/CommonDP/service/XtDesign-service";

export default {
  props: {
    // 唯一标识
    uuid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showPrj: false,
      keyword: "",
      prjOptions: [] // 项目列表
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj
    }),
    // 流程类型 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
    flowType() {
      return getApprove(this.uuid).flowType;
    },
    prjId() {
      return getApprove(this.uuid).prjId || this.prjInfo.prjId || "";
    },
    prjName() {
      const list = this.prjOptions || [];
      const curPrj = list.find((item) => item.prjId === this.prjId) || {};
      return curPrj.prjName || "";
    },
    readonly() {
      return !(this.flowType === 1 || this.flowType === 4 || this.flowType === 5);
    }
  },
  mounted() {
    this.getPrjOptions();
  },
  methods: {
    // 打开关联计划弹框
    openPri() {
      if (this.readonly) return;
      this.showPrj = true;
    },

    // 获得项目列表
    async getPrjOptions() {
      const params = {
        enterpriseId: this.enterpriseId,
        pageNum: 1,
        pageSize: 999,
        keyword: this.keyword
      };
      const { data } = await XtDesignService.getProjectsByUserIdWithPage(params);
      this.prjOptions = data || [];
    },
    // 确定项目
    priConfirm(option) {
      if (option) {
        const { prjId } = option;
        getApprove(this.uuid).setPrjId(prjId);
      }
      this.showPrj = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.prjSelectH5 {
  width: 100%;
  margin-bottom: 10px;
}

.searchRow {
  margin: 5px 0;
}
.oneCell {
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  color: #606266;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.empty {
  height: 200px;
  line-height: 200px;
  text-align: center;
  color: var(--info-color);
  font-size: 16px;
}
</style>
